import { Link } from 'react-router-dom';

const ANCHORS = [
  { id: 'weather', label: 'Weather' },
  { id: 'beach', label: 'Beach' },
  { id: 'tide', label: 'Tide' },
  { id: 'dining', label: 'Dining' },
  { id: 'travel', label: 'Traffic' }
];

export default function JumpNav() {
  return (
    // Solid paper, not a translucent blur. Over anything dark the 80% cream
    // composited to #CFD0CE, a cool grey found nowhere else in the palette,
    // and it read as a rendering fault across the bottom of the first screen
    // (design review 2026-09-26, finding 4).
    <nav
      aria-label="Jump to section"
      className="fixed inset-x-0 bottom-0 z-30 border-t border-navy-100 bg-cream-50 sm:hidden"
    >
      {/* py-2.5 pills: at py-1.5 they were 28px tall, under the tap floor. At
          36px the bar is 53px, still inside the pb-20 Today.jsx keeps for it.
          no-underline: the global link underline made the bar read as a row
          of body links rather than a tab bar. */}
      <ul className="mx-auto flex max-w-brief items-center justify-between gap-1 px-3 py-2">
        {ANCHORS.map((a) => (
          <li key={a.id}>
            <a
              href={`#${a.id}`}
              className="block rounded-full px-3 py-2.5 text-xs font-medium text-navy-700 no-underline hover:bg-cream-100 active:bg-cream-200"
            >
              {a.label}
            </a>
          </li>
        ))}
        {/* Gold slot: the only item that leaves the page, so it gets fill.
            Points at the /stay index, not at a property. This pill survived the
            100199b host-neutrality pass by omission (that commit touched
            Header/Footer but not this file) and was still deep-linking to
            Object.keys(properties)[0]; the index keeps the mobile conversion path
            without making the brief an ad for one host. */}
        <li>
          <Link
            to="/stay"
            className="block rounded-full bg-cream-500 px-3 py-2.5 text-xs font-semibold text-navy-950 no-underline hover:bg-cream-400 active:bg-cream-600"
          >
            Stay
          </Link>
        </li>
      </ul>
    </nav>
  );
}
